<template>
    <div id="reservation-list">
        <div class="calendar-actions">
            <div class="my-calendars-title" @click="() => (calendarListVisible = !calendarListVisible)">
                <span class="title">{{ $t("calendar.reservations") }}</span>
                <span class="material-icons" v-if="calendarListVisible">expand_less</span>
                <span class="material-icons" v-else>expand_more</span>
            </div>
        </div>
        <div class="list" v-if="calendarListVisible">
            <div v-for="reservation in reservationList" class="item">
                <span class="name" @click="$router.replace(`/reservation/${reservation._id}`)">{{
                    reservation.title
                }}</span>
                <span class="material-icons delete" @click="deleteReservationPlan(reservation._id)">close</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { log2 } from "../../../../utils/log2";
import { CALENDAR_API } from "../../../../api/calendar";

const log = log2("ReservationList");
export default {
    name: "ReservationList",
    components: {},
    props: {},
    data() {
        return {
            calendarListVisible: true,
            reservationList: [],
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({}),
        deleteReservationPlan(reservationId) {
            this.$confirm({
                title: "Bu rezervasyonu silmek istediğinize emin misiniz?",
                onOk: async () => {
                    CALENDAR_API.deleteReservationPlan(reservationId).then((res) => {
                        this.reservationList = this.reservationList.filter((item) => item._id !== reservationId);
                        this.$message.success("Rezervasyon başarıyla silindi.");
                    });
                },
            });
        },
    },
    async mounted() {
        CALENDAR_API.getReservationList(this.user._id).then((res) => {
            this.reservationList = res;
        });
    },
    watch: {},
};
</script>

<style lang="scss" scoped>
#reservation-list {
    .calendar-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .my-calendars-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;
            cursor: pointer;
            width: 60%;

            .title {
                font-weight: 700;
                font-size: 17px;
            }
        }
    }

    .list {
        margin-left: 10px;
    }

    .item {
        font-size: 13px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 3px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &:hover {
            background-color: #f3f3f3;
            border-radius: 5px;
        }
    }

    .name {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .delete {
        font-size: 16px;
        color: #a41b1b;
        cursor: pointer;
        padding: 2px;
        border-radius: 3px;

        &:hover {
            background-color: #cecece;
        }
    }
}
</style>
